import React from 'react'
import PropTypes from 'prop-types'

const HeaderSearchSuggestions = ({ labels, ...props }) => {
  return (
    <div className="header-search-suggestions" aria-hidden={props.isVisible ? null : 'true'}>
      <h3 className="header-search-suggestions__title" id="header-search-suggestions-title">{labels.searchResults}</h3>
      <ul
        className="header-search-suggestions__items"
        aria-labelledby="header-search-suggestions-title"
        role="listbox"
        id="header-search-suggestions"
      >
        {props.items.map((item, i) => (
          <li
            onMouseDown={() => window.location = item.Url} key={item.Guid}
            className={`header-search-suggestions__item ${props.focusedIndex === i ? 'header-search-suggestions__item--focused' : ''}`}
          >
            <span className="header-search-suggestions__heading">{item.Title}</span>
            <span className="header-search-suggestions__info">
              {item.ContentType}
              {/* Adds spacing between the terms, this seems better than using HTML tags and CSS for this particular case */}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {item.Institution}
            </span>
          </li>
        ))}
      </ul>
      <span
        className="btn header-search-suggestions__cta"
        onMouseDown={props.onViewAllClick}
      >
        {labels.viewAll}
      </span>
    </div>
  )
}

HeaderSearchSuggestions.propTypes = {

}

export default HeaderSearchSuggestions
